module.exports = __webpack_public_path__ + "static/work_Borstnikovo_2023_loop-8b939f5610f9413fe5cedd7697a2c6fe.mp4";